module.exports = __webpack_public_path__ + "static/img/bg_zrdaoshigeren@2x.fc331bfd.png";